<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.country_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.$invalid && v.$anyDirty" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="isOpen" accordion="country" role="tabpanel">
          <div style="height: 400px;">
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_country')}}</p>
              </div>
              <div class="col-6">
                <multiselect
                    @input="emitSelectedValue('countries')"
                    :state="!v.countries.$dirty ? null :(!v.countries.$error)"
                    v-model="countries"
                    :options="options.countryRule"
                    :multiple="true"
                    track-by="value"
                    label="text">
                </multiselect>
                <div class="">
                  <p v-if="v.countries.$dirty && v.countries.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>
            </div>
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_operation')}}</p>
              </div>
              <div class="col-6">
                <b-form-select v-model="operation" @change="emitSelectedValue('operation')" :state="!v.operation.$dirty ? null :(!v.operation.$error)" :options="options.operation"></b-form-select>
                <div class="">
                  <p v-if="v.operation.$dirty && v.operation.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>
            </div>
            <div class="row pr-4 d-flex justify-content-center align-items-start">
              <div class="col-12">
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {userSegment} from "../../../../common/constants/userSegment";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    v: {
      type: Object,
      required: true
    },
    countryForm: Object,
    isEditType: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: String,
      default: null,
      required: false
    },
    methodPost: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    countryDict: function () {
      return this.$store.getters['root/country'];
    },
    isEdited: function () {
      return this.$store.getters[`userSegment/getEditedRule`](userSegment.country);
    }
  },
  mounted() {
    this.countryDict.forEach(country => {
      const option = {
        value: country.key,
        text: country.label
      }

      this.options.countryRule.push(option);
    });

    this.$parent.$on('checkValidation', () => {
      this.v.$touch();
    });

    if(this.countryForm.countries.length > 0) {
      this.countries = this.countryForm.countries;
      this.operation = this.countryForm.operation;

      this.country = this.options.countryRule.filter(rule => {
        if(this.countryForm.countries.includes(rule.country)) {
          return rule;
        }
      });
    }
  },
  data() {
    return {
      isOpen: false,
      countries: [],
      operation: '',
      options: {
        countryRule: [
          { value: null, text: this.$t('segment.country_placeholder'), $isDisabled: true }
        ],
        operation: [
          {value: 'IN', text: this.$t('segment.option.in')},
          {value: 'NOT_IN', text: this.$t('segment.option.not_in')}
        ]
      }
    }
  },
  methods: {
    saveEditedRule() {
      this.$parent.$emit('editRule', {type: userSegment.country, ruleId: this.ruleId, methodPost: this.methodPost});
    },
    deleteSegmentRule() {
      this.$parent.$emit('deleteSegmentRule', this.ruleId);
    },
    destroy() {
      const data = {
        component: this,
        rule: userSegment.country,
        ruleId: this.ruleId
      }

      this.$parent.$emit('removeCountryRule', data);
    },
    setIsOpen() {
      if(this.isEditType && !this.isEdited) {
        this.isOpen = !this.isOpen;
        return;
      } else if(this.isEditType && this.isEdited) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    emitSelectedValue(type) {
      if(this.isEditType) {
        const data = {
          key: userSegment.country,
          value: true
        }

        this.$store.commit('userSegment/setEditedRule', data);
      }
      this.$parent.$emit('selectedCountry', {type: type, countries: this.countries, operation: this.operation});
    }
  }
}
</script>